<template>
    <!--课程列表-->
    <div class="course content">
        <CourseBread />
        <div class="curr_btn">
            <Button type="primary" @click="addCourse()">添加课程</Button>
            <div class="accountAudit_top">
                <Form :label-width="50" style="display: inline-block;width: 100%;">
                    <FormItem label="名称:" style="display: inline-block;width: 50%;">
                        <Input v-model="name" @keyup.enter.native="search()"></Input>
                    </FormItem>
<!--                    <FormItem label="类型:" style="display: inline-block;width: 50%;">
                        <Select v-model="type" @on-change="changeVal(type)">
                            <Option value="1">体验课</Option>
                            <Option value="2">正式课</Option>
                        </Select>
                    </FormItem>-->
                </Form>
            </div>
            <Button
                style="margin-left: 20px; margin-top: 10px"
                type="info"
                @click="search()"
                class="addBtn"
            >搜索</Button>
        </div>
        <div class="curr_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="courseList"></Table>
        </div>
        <page-component class="page" :page-size="page.size" :total-num="page.total" :page-num="page.current"
            v-on:changePage="changePage" v-on:changePageSize="changePageSize"
            v-on:clickPage="changePage"></page-component>

    </div>
</template>
<style scoped>
.accountAudit_top {
    width: 500px;
    display: inline-block;
}
</style>
<script>
import pageComponent from "../common/page.vue";
import http from "../../libs/http.js";
import { mapActions, mapGetters } from "vuex";
import CourseBread from "./components/CourseBread.vue";
export default {
    components: {
        pageComponent,
        CourseBread,
    },
    data() {
        return {
            name: "",
            type: this.$route.query.type,
            loading: false,
            courseList: [],
            page: {
                total: 1,
                current: 1,
                size: 10
            },
            columns: [
                {
                    title: "课程类型",
                    key: "name",
                    align: "center"
                },
                /*{
                    title: "课程类型",
                    key: "courseType",
                    align: "center",
                },*/
                {
                    title: "最后更新时间",
                    key: "updateTime",
                    align: "center",
                    render: (h, params) => {
                        const date = new Date(params.row.updateTime);
                        const formattedDate = `${date.getFullYear()}-${
                            (date.getMonth() + 1).toString().padStart(2, '0')
                        }-${date.getDate().toString().padStart(2, '0')} ${
                            date.getHours().toString().padStart(2, '0')
                        }:${date.getMinutes().toString().padStart(2, '0')}:${
                            date.getSeconds().toString().padStart(2, '0') // 添加秒的显示
                        }`;

                        return h("div", formattedDate);
                    }
                },
                {
                    title: "修改人",
                    key: "updateUser",
                    align: "center",
                },
                {
                    title: "操作",
                    //                        width: 300,
                    key: "action",
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    height: "70px",
                                    paddingTop: "25px"
                                }
                            },
                            [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                            disabled:
                                                this.sectionStatus == 1
                                                    ? this.getLimit == 1 ||
                                                    this.getLimit == 6 ||
                                                    this.getLimit == 11
                                                        ? false
                                                        : true
                                                    : false,
                                        },
                                        style: {
                                            marginRight: "10px",
                                        },
                                        on: {
                                            click: () => {
                                                this.addCourse(params.row.courseId);
                                            },
                                        },
                                    },
                                    "编辑课程"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "10px"
                                        },
                                        on: {
                                            click: () => {
                                                this.$router.push({
                                                    path: "section",
                                                    query: {
                                                        type: this.type,
                                                        courseStatus:
                                                            params.row.status,
                                                        courseId:
                                                            params.row.courseId,
                                                        courseTitle:
                                                            params.row.name
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    "课节列表"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                            disabled:
                                                this.sectionStatus == 1
                                                    ? this.getLimit == 1 ||
                                                    this.getLimit == 6 ||
                                                    this.getLimit == 11
                                                        ? false
                                                        : true
                                                    : false,
                                        },
                                        style: {
                                            marginRight: "5px",
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteCourse(params.row.courseId);
                                            },
                                        },
                                    },
                                    "删除"
                                ),
                            ]
                        );
                    }
                }
            ]
        };
    },
    created() {
        this.setRecord(null);
    },
    mounted() {
        this.getCourse( this.type, this.name,this.page);
    },
    methods: {
        //筛选状态
        changeVal(val) {
            this.val = val;
            this.getCourse(val, this.searchName, 1, 10);
        },
        //姓名搜索
        search() {
            this.getCourse(
                this.type,
                this.name,
                this.page
            );
        },
        ...mapActions(["setRecord"]),
        //当前页数
        changePage(current) {
            this.page.current = current;
            this.getCourse( this.type, this.name,this.page);
        },
        //当前每页显示的条数
        changePageSize(data) {
            this.page.size = data;
            this.getCourse(this.type, this.name,this.page);
        },
        //获取课程列表
        getCourse(type ,name,page) {
            if (!type) {
                this.$Message.success('请选择课程分类');
                return;
            }
            if (type != 1 && type != 2) {
                this.$Message.success('请选择正确的课程分类');
                return;
            }
            let that = this;
            that.loading = true;
            const { current, size } = page
            http.get("/madyCourse/list", {
                type,
                name,
                current, size
            }).then(res => {
                that.loading = false;
                if (res) {
                    that.courseList = res.records;
                    that.page.current = res.current;
                    that.page.total = res.total;
                }
            });
        },
        // 点击添加/编辑课程事件
        addCourse(courseId) {
            console.log('---------'+courseId)
            if (courseId) {
                this.$router.push({
                    path: "addCourse",
                    query: { courseId: courseId, type: this.type }
                });
            } else {
                this.$router.push({ path: "addCourse", query: { type: this.type } });
            }
        },
        deleteCourse(id) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定删除该课程?",
                onOk: () => {
                    http.post("/madyCourse/deletes", [id]).then((res) => {
                        if (res) {
                            that.getCourse(this.type, this.name,this.page);
                            that.$Message.success("删除成功");
                        }
                    });
                },
            });
        },
    },
    computed: {
        ...mapGetters(["getLimit"])
    }
};
</script>
